var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsuarios({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 64 64",
    height: 300,
    viewBox: "0 0 64 64",
    width: 300,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    width: "100%",
    height: "100%",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "CIRCLE_25_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m31.948 33.564c-1.77 0-3.508-.45-5.028-1.304-4.371-2.453-6.394-7.857-4.706-12.571 1.475-4.117 5.426-6.884 9.833-6.884.587 0 1.177.052 1.754.152 4.897.857 8.589 5.258 8.589 10.236 0 2.356-.811 4.664-2.283 6.499-1.944 2.425-4.995 3.872-8.159 3.872zm.1-18.758c-3.509 0-6.778 2.286-7.95 5.559-1.363 3.807.271 8.171 3.802 10.152 1.221.686 2.621 1.048 4.048 1.048 2.563.001 5.031-1.167 6.601-3.123 1.188-1.48 1.843-3.345 1.843-5.247 0-4.021-2.981-7.574-6.934-8.267-.464-.081-.938-.122-1.41-.122z",
    fill: "#393d47",
    fillOpacity: 1,
    "data-original-color": "#000000ff",
    stroke: "none",
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "ARC_55_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m45.426 27.671c-1.793 0-3.538-.677-4.896-1.985-.398-.383-.41-1.017-.027-1.414s1.017-.409 1.414-.026c1.946 1.872 4.381 1.645 6.011.804 1.632-.84 3.236-2.69 2.842-5.365-.416-2.822-2.704-4.103-4.537-4.342-1.835-.242-4.374.412-5.501 3.036-.218.508-.809.742-1.313.524-.508-.219-.742-.807-.524-1.313 1.291-3.004 4.274-4.666 7.598-4.23 3.325.435 5.781 2.803 6.256 6.034.452 3.063-1.082 5.981-3.906 7.435-1.101.566-2.27.842-3.417.842z",
    fill: "#393d47",
    fillOpacity: 1,
    "data-original-color": "#000000ff",
    stroke: "none",
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "ARC_56_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m47.652 40.629c-.552 0-1-.448-1-1 0-3.333-2.711-6.044-6.043-6.044-.552 0-1-.447-1-1 0-.552.448-1 1-1 4.435 0 8.043 3.608 8.043 8.044 0 .552-.447 1-1 1z",
    fill: "#393d47",
    fillOpacity: 1,
    "data-original-color": "#000000ff",
    stroke: "none",
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "LINE_76_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m40.609 33.585h-17.218c-.552 0-1-.447-1-1 0-.552.448-1 1-1h17.218c.552 0 1 .448 1 1 0 .553-.448 1-1 1z",
    fill: "#393d47",
    fillOpacity: 1,
    "data-original-color": "#000000ff",
    stroke: "none",
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "ARC_57_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m16.348 40.629c-.552 0-1-.448-1-1 0-4.436 3.608-8.044 8.043-8.044.552 0 1 .448 1 1 0 .553-.448 1-1 1-3.333 0-6.043 2.711-6.043 6.044 0 .552-.448 1-1 1z",
    fill: "#393d47",
    fillOpacity: 1,
    "data-original-color": "#000000ff",
    stroke: "none",
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "ARC_58_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m18.591 27.683c-1.25 0-2.523-.334-3.714-1.016-2.883-1.649-4.258-4.75-3.505-7.898.728-3.038 3.261-5.179 6.454-5.452 3.191-.276 6.047 1.403 7.28 4.272.218.507-.017 1.095-.524 1.313-.505.218-1.095-.017-1.313-.524-1.075-2.503-3.429-3.227-5.271-3.068-1.846.158-4.044 1.272-4.679 3.925-.658 2.75.964 4.787 2.553 5.697 1.591.909 4.172 1.276 6.213-.688.398-.382 1.032-.37 1.414.027.383.398.371 1.031-.027 1.414-1.373 1.321-3.102 1.998-4.881 1.998z",
    fill: "#393d47",
    fillOpacity: 1,
    "data-original-color": "#000000ff",
    stroke: "none",
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "LINE_77_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m12.348 39.455h-2.348c-.552 0-1-.448-1-1 0-.553.448-1 1-1h2.348c.552 0 1 .447 1 1 0 .552-.448 1-1 1z",
    fill: "#393d47",
    fillOpacity: 1,
    "data-original-color": "#000000ff",
    stroke: "none",
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE_18_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m8 37.455c-.552 0-1-.448-1-1v-5.044c0-3.141 2.555-5.695 5.696-5.695h5.739c.552 0 1 .447 1 1 0 .552-.448 1-1 1h-5.739c-2.038 0-3.696 1.657-3.696 3.695v5.044c0 .552-.448 1-1 1z",
    fill: "#393d47",
    fillOpacity: 1,
    "data-original-color": "#000000ff",
    stroke: "none",
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "ARC_59_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m10 39.455c-1.654 0-3-1.346-3-3 0-.553.448-1 1-1s1 .447 1 1c0 .551.449 1 1 1 .552 0 1 .447 1 1 0 .552-.448 1-1 1z",
    fill: "#393d47",
    fillOpacity: 1,
    "data-original-color": "#000000ff",
    stroke: "none",
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "LINE_78_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m16.348 49.194c-.552 0-1-.448-1-1v-8.565c0-.553.448-1 1-1s1 .447 1 1v8.565c0 .552-.448 1-1 1z",
    fill: "#393d47",
    fillOpacity: 1,
    "data-original-color": "#000000ff",
    stroke: "none",
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "ARC_60_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m18.348 51.194c-1.654 0-3-1.346-3-3 0-.553.448-1 1-1s1 .447 1 1c0 .551.449 1 1 1 .552 0 1 .447 1 1 0 .552-.448 1-1 1z",
    fill: "#393d47",
    fillOpacity: 1,
    "data-original-color": "#000000ff",
    stroke: "none",
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "LINE_79_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m45.652 51.194h-27.304c-.552 0-1-.448-1-1 0-.553.448-1 1-1h27.305c.552 0 1 .447 1 1-.001.552-.448 1-1.001 1z",
    fill: "#393d47",
    fillOpacity: 1,
    "data-original-color": "#000000ff",
    stroke: "none",
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "LINE_80_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m47.652 49.194c-.552 0-1-.448-1-1v-8.565c0-.553.448-1 1-1s1 .447 1 1v8.565c0 .552-.447 1-1 1z",
    fill: "#393d47",
    fillOpacity: 1,
    "data-original-color": "#000000ff",
    stroke: "none",
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "ARC_61_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m45.652 51.194c-.552 0-1-.448-1-1 0-.553.448-1 1-1 .551 0 1-.449 1-1 0-.553.448-1 1-1s1 .447 1 1c0 1.655-1.345 3-3 3z",
    fill: "#393d47",
    fillOpacity: 1,
    "data-original-color": "#000000ff",
    stroke: "none",
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "LINE_81_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m54 39.455h-2.348c-.552 0-1-.448-1-1 0-.553.448-1 1-1h2.348c.552 0 1 .447 1 1 0 .552-.448 1-1 1z",
    fill: "#393d47",
    fillOpacity: 1,
    "data-original-color": "#000000ff",
    stroke: "none",
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE_19_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m56 37.455c-.552 0-1-.448-1-1v-5.044c0-2.038-1.658-3.695-3.696-3.695h-5.739c-.552 0-1-.448-1-1 0-.553.448-1 1-1h5.739c3.141 0 5.696 2.555 5.696 5.695v5.044c0 .552-.448 1-1 1z",
    fill: "#393d47",
    fillOpacity: 1,
    "data-original-color": "#000000ff",
    stroke: "none",
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "ARC_62_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m54 39.455c-.552 0-1-.448-1-1 0-.553.448-1 1-1 .551 0 1-.449 1-1 0-.553.448-1 1-1s1 .447 1 1c0 1.654-1.346 3-3 3z",
    fill: "#393d47",
    fillOpacity: 1,
    "data-original-color": "#000000ff",
    stroke: "none",
    strokeOpacity: 1
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsuarios);
export default __webpack_public_path__ + "static/media/usuarios.78fc5e8b6fa4d3122c38dc16a94aabbc.svg";
export { ForwardRef as ReactComponent };